import { memo, useContext } from 'react';
import Checkbox from '../../common/checkbox/checkbox';
import { StylesContext } from '../../../contexts/styles-context/styles.context';
import styles from './agreement.module.scss';

interface AgreementProps {
	checked: boolean;
  onChange: (value: boolean) => void;
  privacyPolicyUrl: string;
}

export const Agreement = memo(({ checked, onChange, privacyPolicyUrl }:AgreementProps) => {
	const { styles: customStyles } = useContext(StylesContext);

	return (
		<span className={styles.agreement}>
			<input 
				id='agreement'
				type='checkbox' 
				checked={checked}
				onChange={e => onChange(e.currentTarget.checked)}
			/>
			<label htmlFor='agreement'>
				<Checkbox customStyles={customStyles.agreementCheckbox} type='agreement' checked={checked} />
				Согласен с&nbsp;
			</label>
			<a href={privacyPolicyUrl} rel='noopener noreferrer' target='_blank'>политикой конфиденциальности</a>
		</span>
	);
});